// extracted by mini-css-extract-plugin
export default {"header":"PlacementPerformance_header__AfZ+c"};